import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class PaymentService {

  controller = 'Payment';

 
  constructor(private base: BaseService,
    private http:HttpClient) { }


get(paymentId: any){
    return this.http.get("https://pay.aldawal.com/GetPayment/"+paymentId);
}

gets(systemId: any,companyId:any) {
    return this.http.get("https://pay.aldawal.com/GetPaymentsByCompanyId/"+systemId+"/"+companyId);
}

// getAllPaymentForUser(id: any): Observable<ApiObjectData> {
//     return this.base.gets(this.controller + '/GetAllPaymentForUser/' + id)
// }

save(obj: any) {
    return this.http.post('https://pay.aldawal.com/SavePayment', obj);
}

}